<template>
  <v-container>
    <v-layout row>
      <v-flex xs4>
        <div class="footer-section">
          <h3 class="text-uppercase">
            Discover
          </h3>
          <ul>
            <li>
              <a href="https://laravel.com/">Laravel</a>
            </li>
          </ul>
        </div>
      </v-flex>
      <v-flex xs4>
        <div class="footer-section">
          <h3 class="text-center text-uppercase">
            Follow
          </h3>
          <ul class="text-center">
            <li>
              <a href="https://github.com/alphazento/alphazento">Github</a>
            </li>
          </ul>
        </div>
      </v-flex>
      <v-flex xs4>
        <div class="footer-section">
          <h3 class="text-right text-uppercase">
            Support
          </h3>
          <ul class="text-right">
            <li>
              <a href="https://www.alphazento.com/">Sponsor Alphazento</a>
            </li>
          </ul>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-spacer></v-spacer>
      <div class="text-center footer-bar">
        <span>Copyright © 2020</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 312 335"
          width="30"
          height="25"
          class="logo-svg"
        >
          <path
            id="Shape 2"
            class="shp0"
            d="M0 335C180.51 62.98 167 -94.55 187 64C207 222.55 79.46 227.14 172 225C264.54 222.86 14.02 306.65 115 301C215.98 295.35 437.27 284.27 219 313"
          />
        </svg>
        <span> Alphazento All rights reserved.</span>
      </div>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "footerbar",
  data: () => ({}),
};
</script>
